import { render, staticRenderFns } from "./headerAddress.vue?vue&type=template&id=465e749a&scoped=true"
import script from "./headerAddress.vue?vue&type=script&lang=js"
export * from "./headerAddress.vue?vue&type=script&lang=js"
import style0 from "./headerAddress.vue?vue&type=style&index=0&id=465e749a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e749a",
  null
  
)

export default component.exports